"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorReplacer = void 0;
/**
 * Custom replacer function for JSON.stringify to handle Error objects.
 *
 * This function will transform Error objects into plain objects with
 * their key properties, making them more suitable for serialization.
 *
 * @param {*} value - The value to be processed. If it is an instance of Error, it will be transformed.
 * @returns {*} - The original value if not an Error, otherwise an object with the Error properties.
 */
var errorReplacer = exports.errorReplacer = function errorReplacer(value) {
  if (value instanceof Error) {
    return {
      message: value.message,
      name: value.name,
      fileName: value.fileName,
      lineNumber: value.lineNumber,
      columnNumber: value.columnNumber
    };
  }
  return value;
};